import type { SendingFacility } from '../../helpers/sendingFacility';

import Pills from './Pills';
import Text from './Text';
import { t } from '../i18n/langue';

/**
 * « Envoyé en tant que : Le Limas » — retour Odomo 2026-09 : l'hôtelier est
 * souvent en vue groupe sur mobile sans le savoir. Plusieurs hôtels possibles :
 * des pastilles, sans présélection — le choix est explicite.
 */
interface LigneEnvoyeEnTantQueProps {
    options: SendingFacility[];
    identite: SendingFacility | null;
    onChoisir: (facilityId: number) => void;
}

export default function LigneEnvoyeEnTantQue({ options, identite, onChoisir }: LigneEnvoyeEnTantQueProps) {
    if (options.length > 1) {
        return (
            <div className="border-t border-border-color-light bg-white px-4 py-2">
                <Text variante="petit" ton="marque" className="mb-2 font-semibold">
                    {identite ? t('composeur.envoyeEnTantQue') : t('composeur.choisirHotel')}
                </Text>
                <Pills
                    libelle={t('composeur.hotelEnvoi')}
                    options={options.map((o) => ({ valeur: String(o.facility_id), libelle: o.facility_name }))}
                    valeur={identite ? String(identite.facility_id) : ''}
                    onChange={(valeur) => onChoisir(Number(valeur))}
                />
            </div>
        );
    }

    return (
        <Text variante="petit" ton="marque" className="border-t border-border-color-light bg-white px-4 py-2">
            {t('composeur.envoyeEnTantQue')} <span className="font-semibold">{identite?.facility_name}</span>
        </Text>
    );
}
